// The pending badge in the Action Queue filter bar.
//
// It renders directly beside the brand selector, so it must count the SELECTED
// brand. It used to always show the all-brands total, which meant narrowing the
// filter to a brand with no pending work still displayed e.g. "8 Pending" right
// next to that brand's name — reading as "this client has 8 items awaiting you".
// Observed on dev 2026-08-20: filter set to boots-uk.com, list correctly empty,
// badge still claimed 8.
//
// Kept as a pure function so the rule is testable without mounting the page.

/** Sentinel value used by the brand <select> for "every brand". */
export const ALL_SHOPS_SENTINEL = '__all__';

export interface BrandOption {
  slug: string;
  count: number;
}

/**
 * How many pending proposals the badge should claim, for the brand currently
 * selected in the filter.
 *
 * @param shopFilter    current value of the brand selector
 * @param totalPending  pending count across every brand
 * @param brandOptions  per-brand options, each carrying its own pending count
 */
export function pendingBadgeCount(
  shopFilter: string,
  totalPending: number,
  brandOptions: BrandOption[]
): number {
  if (shopFilter === ALL_SHOPS_SENTINEL || shopFilter === '') {
    return totalPending;
  }

  // An unknown slug means "no pending work for it" — never fall back to the
  // all-brands total, which is the bug this function exists to prevent.
  return brandOptions.find((b) => b.slug === shopFilter)?.count ?? 0;
}
